

export function trackEvent(eventName: string, data) {
    if ((window as any).plausible) {
        (window as any).plausible(eventName, {
            props: data
        });
    }
}
